export interface ComicApp {
  id: string;
  name: string;
  platform: string;
  desc: string;
  features: string[];
  size: string;
  rating: string;
  downloads: string;
  update: string;
  color: string;
}

export const comicApps: ComicApp[] = [
  {
    id: 'a1',
    name: '韩漫阅读器',
    platform: 'Android / iOS',
    desc: '聚合多站韩漫源的阅读器，支持无遮拦日更在线看，缓存离线也能追更，是手机端看韩漫的主力选择。',
    features: ['多源聚合', '离线缓存', '无遮拦'],
    size: '42.6MB',
    rating: '9.5',
    downloads: '10万+',
    update: '今日更新',
    color: '#ff5f2e',
  },
  {
    id: 'a2',
    name: '梨漫画App',
    platform: 'Android',
    desc: '专注高清无遮拦韩漫的APP，原画质直出，更新极快，连载同步精准，适合对画质有高要求的读者。',
    features: ['原画直出', '更新极快', '无遮拦'],
    size: '38.2MB',
    rating: '9.3',
    downloads: '8万+',
    update: '今日更新',
    color: '#f2c94c',
  },
  {
    id: 'a3',
    name: '首尔漫画',
    platform: 'iOS / Android',
    desc: '双端皆可用的韩漫APP，界面清爽，支持收藏与追更提醒，新作上线第一时间推送。',
    features: ['双端可用', '追更提醒', '界面清爽'],
    size: '51.8MB',
    rating: '9.1',
    downloads: '6万+',
    update: '隔日更新',
    color: '#7bab97',
  },
  {
    id: 'a4',
    name: '泡菜漫画Pro',
    platform: 'Android',
    desc: '收录最全的韩漫APP，覆盖海量连载与完结作品，搜索精准，支持多线路切换避免卡顿。',
    features: ['收录最全', '搜索精准', '多线路'],
    size: '45.7MB',
    rating: '9.0',
    downloads: '7万+',
    update: '每日更新',
    color: '#ff7a4d',
  },
  {
    id: 'a5',
    name: '汉江漫画',
    platform: 'Android',
    desc: '老牌稳定的韩漫APP，运营多年资源存档完整，几乎无广告弹窗，适合长期追更的用户。',
    features: ['运营稳定', '无广告', '存档全'],
    size: '33.9MB',
    rating: '8.9',
    downloads: '5万+',
    update: '每周更新',
    color: '#93c0ac',
  },
  {
    id: 'a6',
    name: '仁川阅读',
    platform: 'iOS',
    desc: '主打iOS端的韩漫阅读器，支持夜间模式与缓存阅读，界面精致，体验流畅。',
    features: ['夜间模式', '缓存阅读', '界面精致'],
    size: '48.4MB',
    rating: '8.8',
    downloads: '3万+',
    update: '隔日更新',
    color: '#ff9a73',
  },
];